import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function Temperature(props) {
  const className = props.balance
    ? `${style.temperature_current}`
    : `${style.temperature_current_inBalance}`;

  const openModalWindow = () => {
    return props.toggleModal(!props.isModalOpen);
  };

  return (
    <div className={style.temperature}>
      <h3 className={style.temperature_set} onClick={openModalWindow}>
        {props.temperature}°C
      </h3>
      <h3 className={className} onClick={openModalWindow}>
        {props.currentTemp}°C
      </h3>
    </div>
  );
}
Temperature.propTypes = {
  /**
   * Modal window to open when clicking on the HeatBlock
   */
  isModalOpen: PropTypes.bool.isRequired,
  /**
   * Function to triger the modalwindow,to change the state 'isModalOpen'
   */
  toggleModal: PropTypes.func,
  /**
   * State to store the setTemperature value
   */
  temperature: PropTypes.number,
  /**
   * State to store the currentTemp value
   */
  currentTemp: PropTypes.number,
  /**
   * It denotes the current temperature and the setTemperature is equal or not
   */
  balance: PropTypes.bool,
};
